(function ($, Drupal, once) {
  const isIOS = () => {
    const platform = navigator.platform || '';
    const userAgent = navigator.userAgent || '';
    const maxTouchPoints = navigator.maxTouchPoints || 0;

    return /iPad|iPhone|iPod/.test(userAgent) ||
      (platform === 'MacIntel' && maxTouchPoints > 1);
  };

  const getTodayValue = () => new Date().toISOString().slice(0, 10);

  class CustomDate {
    constructor($dateInput) {
      if (!$dateInput.attr('disabled')) {
        this.id = $dateInput.attr('id');
        $dateInput.removeAttr('id');
        const placeholder = $dateInput.attr('placeholder') || Drupal.t('Date');
        this.$customInput = $(
          `<input type="text" id="${
            this.id
          }" placeholder="${placeholder}" class="custom-date ${$dateInput.attr(
            'class',
          )} "/>`,
        );
        this.$dateInput = $dateInput;
        this.$dateInput.after(this.$customInput);
        this.$dateInput.addClass('visually-hidden');
        this.$customInput.removeClass('required');
        this.$customInput.on('touchstart mousedown', this.onInteractionStart.bind(this));
        this.$customInput.on('focus', this.onFocus.bind(this));
        this.$dateInput[0].addEventListener('change', this.onNativeChangeCapture.bind(this), true);
        this.$dateInput.on('input', this.mapDate.bind(this));
        this.$dateInput.on('change', this.mapDate.bind(this));
        this.mapDate(false);
      }
    }

    onInteractionStart() {
      this.initialValue = this.$dateInput.val();
      this.openedAt = Date.now();
    }

    onFocus() {
      this.onInteractionStart();
      this.$dateInput.focus();
      if (typeof this.$dateInput[0].showPicker === 'function') {
        this.$dateInput[0].showPicker();
      }
    }

    onNativeChangeCapture(event) {
      const currentValue = this.$dateInput.val();

      // On iOS/WebKit, opening a hidden native date input via script can
      // immediately assign today's date before the user chooses anything.
      // Clear that synthetic value before downstream change handlers apply a
      // facet filter or close the mobile drawer.
      if (
        isIOS() &&
        !this.initialValue &&
        currentValue === getTodayValue() &&
        this.openedAt &&
        Date.now() - this.openedAt < 250
      ) {
        this.$dateInput.val('');
        this.mapDate(false);
        event.preventDefault();
        event.stopImmediatePropagation();
        return false;
      }

      this.initialValue = undefined;
      this.openedAt = undefined;
      return true;
    }

    mapDate(clearErrors = true) {
      const timestamp = Date.parse(this.$dateInput.val());
      if (isNaN(timestamp)) {
        this.$customInput.val('');
        return;
      }

      const formattedDate = new Intl.DateTimeFormat('en-GB', {
        day: 'numeric',
        month: 'short',
        year: '2-digit',
      }).format(new Date(timestamp));
      this.$customInput.val(formattedDate);
      if (clearErrors) {
        this.$dateInput.parent().parent().find('.invalid-feedback').text('');
        this.$dateInput.removeClass('is-invalid');
        this.$customInput.trigger('change');
      }
    }
  }

  Drupal.behaviors.veoliaDate = {
    attach: (context) => {
      $(once('input-date', 'input[type="date"]', context)).each(function () {
        new CustomDate($(this));
      });

      const rowCount = $('.add-waste-type-wrapper table tr').length;
      if (rowCount <= 2) {
        $('.add-waste-type-wrapper table').addClass('singletr');
      }
    },
  };
}(jQuery, Drupal, once));
